export class Part {
  public id: number;
  public name: string;
  public code: string;
  public description: string;
  public stockAmount: number;
  public openOrdersAmount: number;
  public supplierPart: SupplierPart | null;
  public freeStockAmount: number;
  public status: boolean;
}

export interface SupplierPart {
  id: number;
  name: string;
  contactPerson: string;
  email: string;
  supplierPartName: string;
  supplierPartCode: string;
  remark: string;
}

export interface PartForm {
  name: string;
  code: string;
  stockAmount: number;
  supplierPart: {
    name: string;
    contactPerson: string;
    email: string;
    supplierPartName: string;
    supplierPartCode: string;
    remark: string;
  };
}

export interface PartListResponse {
  total: number;
  count: number;
  per_page: number;
  data: Part[];
}

export interface AttachPartsToProductBody {
  parts: {
    id: number;
    amount: number;
    propertyId?: number | null;
  }[];
}

export interface PartProduct {
  amount: number;
  part: Part;
  property?: {
    id: number;
    name: string;
    description: string;
    status: boolean;
    deletedAt: string | null;
    code: string;
  } | null;
}

export interface AttachPartsToOptionBody {
  parts: {
    id: number;
    amount: number;
  }[];
}

export interface PartOption {
  id: number;
  amount: number;
  option: string;
  part: Part;
}